import { Controller } from "stimulus"

// #1632: het formulier Exporteren. Een eigen periode toont de twee datums;
// per groep (trainers, locaties, types) staat "Alle" aan zolang er niets
// gekozen is. Na het versturen sluit het venster, het bestand komt binnen als
// download.
export default class extends Controller {
  static targets = ["periode", "eigen", "groep"]

  connect() {
    this.periode()
  }

  periode() {
    if (!this.hasEigenTarget) return
    const gekozen = this.periodeTargets.find((knop) => knop.checked)
    const eigen = gekozen && gekozen.value === "eigen"
    this.eigenTarget.hidden = !eigen
    this.eigenTarget.querySelectorAll("input").forEach((veld) => { veld.required = eigen })
  }

  // "Alle" aangevinkt: de losse keuzes uit
  alle(event) {
    const groep = event.target.closest("[data-rooster-export-target='groep']")
    if (!groep) return
    if (event.target.checked) {
      groep.querySelectorAll("input[type=checkbox]:not([data-rx-alle])").forEach((vak) => { vak.checked = false })
    } else if (!groep.querySelector("input[type=checkbox]:not([data-rx-alle]):checked")) {
      event.target.checked = true
    }
  }

  // Een losse keuze: "Alle" uit, of weer aan als er niets meer gekozen is
  een(event) {
    const groep = event.target.closest("[data-rooster-export-target='groep']")
    const alle = groep && groep.querySelector("[data-rx-alle]")
    if (!alle) return
    alle.checked = !groep.querySelector("input[type=checkbox]:not([data-rx-alle]):checked")
  }

  verstuurd() {
    const dialoog = this.element.closest("dialog")
    if (dialoog) setTimeout(() => dialoog.close(), 300)
  }
}
